import langs from './lang/index.js';

export const makeItems = lang => {
  const k = langs[lang];

  return {
    tipuriClient: [
      {type: 'casnic', anre_type: 'Casnic', label: k.tip_client_casnic},
      {type: 'noncasnic', anre_type: 'Noncasnic', label: k.tip_client_non_casnic},
    ],
    tipuriOferte: [
      {type: 0, anre_value: 'Oricare', label: k.tip_oferta_oricare},
      {type: 1, anre_value: 'Oferte concurentiale', label: k.tip_oferta_concurentiala},
      {type: 2, anre_value: 'Oferte serviciu universal', label: k.tip_oferta_serviciu_universal},
    ],
    tipuriPreturi: [
      {value: 'nediferentiat', anre_value: 'Nediferentiat', label: k.tip_pret_oferta_nediferentiat},
      {value: 'diferentiat', anre_value: 'Diferentiat pe zone orare', label: k.tip_pret_oferta_diferentiat}
    ],
    tipuriProdus: [
      {type: 0, anre_type: 'Oricare', label: k.tip_produs_oricare},
      {type: 1, anre_type: 'Pret fix', label: k.tip_produs_fix},
      {type: 2, anre_type: 'Pret variabil', label: k.tip_produs_variabil}
    ],
    niveluriTensiuni: [
      {value: 'MT_', anre_value: 'Medie tensiune', label: k.nivel_tensiune_mediu},
      {value: 'JT_', anre_value: 'Joasă tensiune', label: k.nivel_tensiune_jos}
    ],
    perioadeContract: [
      {value: '', anre_value: 'Oricare', label: k.perioada_contract_oricare},
      {value: 1, anre_value: 'mai mica de 1 an', label: k.perioada_contract_sub_1_an},
      {value: 2, anre_value: '1 an', label: k.perioada_contract_1_an},
      {value: 3, anre_value: 'intre 1 an si 2 ani', label: k.perioada_contract_intre_1_an_si_2_ani},
      {value: 4, anre_value: '2 ani', label: k.perioada_contract_2_ani},
      {value: 5, anre_value: 'intre 2 ani si 3 ani', label: k.perioada_contract_intre_2_ani_si_3_ani},
      {value: 6, anre_value: '3 ani', label: k.perioada_contract_3_ani},
      {value: 7, anre_value: 'mai mare de 3 ani', label: k.perioada_contract_mai_mare_de_3_ani},
      {value: 8, anre_value: 'nedeterminata', label: k.perioada_contract_nedeterminata}
    ],
    frecventeEmitereFacturi: [
      {value: '', anre_value: 'Oricare', label: k.frecventa_emitere_factura_oricare},
      {value: 1, anre_value: 'lunar', label: k.frecventa_emitere_factura_lunar},
      {value: 2, anre_value: 'la 2 luni', label: k.frecventa_emitere_factura_2_luni},
      {value: 3, anre_value: 'la 3 luni', label: k.frecventa_emitere_factura_3_luni},
      {value: 4, anre_value: 'altele', label: k.frecventa_emitere_factura_altele}
    ],
    facturaElectronica: [
      {value: '', anre_value: 'Oricare', label: k.factura_electronica_oricare},
      {value: 1, anre_value: 'Posta / Curier', label: k.factura_electronica_posta},
      {value: 2, anre_value: 'E-mail', label: k.factura_electronica_email},
      {value: 3, anre_value: 'Portal', label: k.factura_electronica_portal},
      {value: 4, anre_value: 'Posta/curier si electronic', label: k.factura_electronica_posta_si_email}
    ],
    energieRegenerabila: [
      {value: '', anre_value: 'Oricare', label: k.energie_sursa_regenerabile_oricare},
      {value: 1, anre_value: 'da', label: k.energie_sursa_regenerabile_da},
      {value: 2, anre_value: 'nu', label: k.energie_sursa_regenerabile_nu}
    ],
    frecventeCitireContor: [
      {value: '', anre_value: 'Oricare', label: k.frecventa_citire_contor_oricare},
      {value: 1, anre_value: 'lunar', label: k.frecventa_citire_contor_lunar},
      {value: 2, anre_value: 'la 2 luni', label: k.frecventa_citire_contor_2_luni},
      {value: 3, anre_value: 'la 3 luni', label: k.frecventa_citire_contor_3_luni},
      {value: 4, anre_value: 'la 4 luni', label: k.frecventa_citire_contor_4_luni},
      {value: 5, anre_value: 'la 5 luni', label: k.frecventa_citire_contor_5_luni},
      {value: 6, anre_value: 'la 6 luni', label: k.frecventa_citire_contor_6_luni},
    ],
    valoareFixa: [
      {value: '', anre_value: 'Oricare', label: k.valoare_fixa_oricare},
      {value: 1, anre_value: 'da', label: k.valoare_fixa_da},
      {value: 2, anre_value: 'nu', label: k.valoare_fixa_nu},
    ],
  };
};

const makeForm = (lang, vm) => {
  const items = makeItems(lang);
  const k = langs[lang];

  const rules = {
    tip_client: [
      v => v === undefined ? k.tip_client_rule_required : true,
      v => v && items.tipuriClient.includes(v) ? true : k.tip_client_rule_in,
    ],
    tip_oferta: [
      v => v === undefined ? k.tip_oferta_rule_required : true,
      v => v && items.tipuriOferte.includes(v) ? true : k.tip_oferta_rule_in,
    ],
    consum_lunar: [
      v => v === '' ? k.consum_lunar_rule_required : true,
      v => v && '' + parseInt(v) !== v ? k.consum_lunar_rule_number : true
    ],
    id_judet: [
      v => v === undefined ? k.judet_rule_required : true,
    ],
    data_start_aplicare: [
      v => v === '' ? k.data_start_aplicare_rule_required : true,
    ],
    tip_produs: [
      v => v === undefined ? k.tip_produs_rule_required : true,
      v => v && items.tipuriProdus.includes(v) ? true : k.tip_produs_rule_in
    ],
    nivel_tensiune: [
      v => v === undefined ? k.nivel_tensiune_rule_required : true,
      v => v && items.niveluriTensiuni.includes(v) ? true : k.nivel_tensiune_rule_in,
    ],
    tip_pret_oferta: [
      v => v === undefined ? k.tip_pret_oferta_rule_required : true,
      v => v && items.tipuriPreturi.includes(v) ? true : k.tip_pret_oferta_rule_in,
    ],
    pret_oferta_diferentiat_zi: [
      v => v === '' ? k.pret_oferta_diferentiat_zi_rule_required : true,
      v => v === '' && '' + parseInt(v) !== v ? k.pret_oferta_diferentiat_zi_rule_number : true,
      v => v !== '' && parseInt(v) <= 0 || parseInt(v) >= 100 ? k.pret_oferta_diferentiat_zi_rule_between : true
    ],
    factura_electronica: [
      v => v === undefined || items.facturaElectronica.includes(v) ? true : k.factura_electronica_rule_in,
    ],
    perioada_contract: [
      v => v === undefined || items.perioadeContract.includes(v) ? true : k.perioada_contract_rule_in,
    ],
    frecventa_emitere_factura: [
      v => v === undefined || items.frecventeEmitereFacturi.includes(v) ? true : k.frecventa_emitere_factura_rule_in,
    ],
    frecventa_citire_contor: [
      v => v === undefined || items.frecventeCitireContor.includes(v) ? true : k.frecventa_citire_contor_rule_in,
    ],
    energie_regenerabila: [
      v => v === undefined || items.energieRegenerabila.includes(v) ? true : k.energie_sursa_regenerabile_rule_in,
    ],
    valoare_fixa: [
      v => v === undefined || items.valoareFixa.includes(v) ? true : k.valoare_fixa_rule_in,
    ],
    valoare_factura_curenta: [
      v => v && '' + parseInt(v) !== v ? k.valoare_factura_curenta_required : true
    ],
  };

  return {items, rules, lang: k}
};

export default makeForm;
